<div class="page-header">
  <h1 class="page-title">Skärmar</h1>
  <mat-divider></mat-divider>
</div>

<div class="table-container">
  <mat-toolbar>
    <a mat-flat-button
       color="accent"
       [routerLink]="['/screens/create']">
      <mat-icon class="mr-2"
                inline="true">add</mat-icon>Skapa
    </a>
  </mat-toolbar>
  <table mat-table
         [dataSource]="dataSource"
         class="table-hover"
         matSort
         matSortActive="id"
         matSortDirection="desc">

    <ng-container matColumnDef="id">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> ID. </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.id}} </td>
    </ng-container>

    <ng-container matColumnDef="aiVersion">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Ai Version </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.aiVersion}} </td>
    </ng-container>

    <ng-container matColumnDef="advertiserVersion">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Advertiser Version </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.advertiserVersion}} </td>
    </ng-container>

    <ng-container matColumnDef="humanUniqueIdentifier">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Namn </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.humanUniqueIdentifier}} </td>
    </ng-container>

    <ng-container matColumnDef="location">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Butik </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.location?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="locationDescription">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Placering </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.locationDescription}} </td>
    </ng-container>

    <ng-container matColumnDef="layout">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Skärmlayout </th>
      <td mat-cell
          *matCellDef="let screen">
        <span *ngIf="screen.width && screen.height">
          {{screen.width}}x{{screen.height}}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="defaultMedia">
      <th mat-header-cell
          *matHeaderCellDef
          mat-sort-header> Standardmedia </th>
      <td mat-cell
          *matCellDef="let screen"> {{screen.defaultMedia?.name}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell
          *matHeaderCellDef
          class="actions-col"></th>
      <td mat-cell
          *matCellDef="let screen"
          [style.width]="'1px'">
        <button mat-icon-button
                (click)="onDeleteClick($event, screen)"
                class="delete-button"
                aria-label="delete item">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row
        *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row
        *matRowDef="let screen; columns: displayedColumns;"
        [routerLink]="['/screens', screen.id]"></tr>
  </table>
</div>
